import createVueComponent from '../createVueComponent';

const TerminalSquare = createVueComponent('TerminalSquareIcon', [
  ['path', { d: 'M7 11l2-2-2-2' }],
  ['path', { d: 'M11 13h4' }],
  ['rect', { x: '3', y: '3', width: '18', height: '18', rx: '2', ry: '2' }],
]);

export default TerminalSquare;
